import React from 'react';
import Link from '../Link/Link';
import arrowRight from '../../assets/images/icons/arrow-right.svg';
import Styles from './FittingRecommendations.module.scss';

const FittingRecommendations = (props) => {
  const { recommendations } = props;

  return (
    <div className={Styles.fittingRecommendations}>
      Fitting Recommendation Options
      {recommendations.map((recommendation, index) => {
        return (
          <div key={`recommendation-link-${index}`}>
            <div className={Styles.linkDescription} key={index}>
              <img className={Styles.arrowRight} src={arrowRight} alt='arrow-right' />
              <span className={Styles.description}>{recommendation.description}</span>
            </div>
            <div>
              {recommendation.references.map((reference, i) => {
                return (
                  <div className={Styles.fitRecLinks} key={i}>
                    <Link article={reference} fittingRecLink={true} />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FittingRecommendations;
